import isNil from "lodash/fp/isNil";

class MockResource {
  constructor($q, $timeout) {
    "ngInject";

    this.$q = $q;
    this.$timeout = $timeout;
  }

  getAll() {
    const mockData = {
      hits: [],
    };

    return this.constructPromise(
      mockData,
      !isNil(mockData.hits) && Array.isArray(mockData.hits)
    );
  }

  get() {
    const mockData = {
      data: {},
    };

    return this.constructPromise(mockData);
  }

  constructPromise(mockData, success = true) {
    const promise = this.$q((resolve, reject) => {
      if (success) {
        this.$timeout(() => {
          resolve(mockData);
        }, 1500);
      } else {
        reject("Mocking data failed");
      }
    });

    return { $promise: promise };
  }
}

export default MockResource;



// WEBPACK FOOTER //
// ./src/resources/mock/mock.resource.js